<template>
<div class="main list-view contacts-list">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" class="search" placeholder="Search" v-model="filters.search_term" @keyup.enter="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.type == 'supplier' ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('type')"></span>
				<label>Supplier Contacts</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.type != 'supplier' ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('type')"></span>
				<label>Disposal Contacts</label>
			</li>
		</ul>

		<div class="divider"></div>

		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')" @change="getList()">
		</div>

		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')" @change="getList()">
		</div>

		<div :class="['button', hasFilters() ? 'neutral' : 'disabled' ]" @click="clearFilters(true)">Clear FIlters</div>

		<div class="divider"></div>

		<div v-if="showDetail" :class="['button', contact.client_id == clientId ? 'action' : 'disabled']" @click="saveContact()">Save Contact</div>
		<div v-if="showDetail" class="button neutral" @click="backToList()"><i class="fa fa-arrow-circle-left"></i> Back To List</div>
	</div>

    <loading v-if="loading"></loading>

	<div v-else-if="showDetail" class="detail">
		<div class="section">
			<h2>Contact Info</h2>
			<contact-detail-form :clientId="clientId" :saveMessage="saveMessage" :contact="contact" :hideControls="true" @update="updateContact" @cancel="backToList"></contact-detail-form>
		</div>
		<div class="section">
			<h2>History</h2>
			<div class="scrollable-list">
				<table>
					<tr>
						<th>Date</th>
						<th>Sequence</th>
					</tr>
					<tr class="clickable-list-item" v-for="(history, index) in contact_history" @click="$router.push('/logbooks/list/?id=' + history.ffl_log_book_entry_id)">
						<td>{{ history.date }}</td>
						<td>{{ history.sequence_code }}</td>
					</tr>
				</table>
			</div>
			<!-- <div v-if="filters.type == 'supplier'" class="notes">
				Need to add a supplier contact?
				<div class="inline-link" @click="$router.push('/receive')">Receive new inventory</div>
			</div>
			<div v-else class="notes">
				Need to add a disposal contact?
				<div class="inline-link" @click="$router.push('/dispose')">Dispose inventory</div>
			</div> -->
		</div>
    	<message-modal v-if="saveMessage" :message="saveMessage" :loading="loading" :errorStatus="messageErrorStatus" @dismiss="saveMessage = ''" />

	</div>

	<list-component v-else class="list logbook-entries" :definition="definition" :list="list" @clicked="getDetail($event)"></list-component>

	<help-popup :helpLink="{214:'Logbook Contacts', 215:'Logbook Contact Detail'}" :tours="false"></help-popup>

</div>
</template>

<script>
import ListComponent from '../components/ListComponent'
import ContactDetailForm from '@/components/ContactDetailForm'
import HelpPopup from '@/components/HelpPopup.vue'

//import MessageModal from '@/components/MessageModal.vue'
export default {
	name: 'suppliers',
	props: ['contact_id','type'],
    components: {
        'list-component': ListComponent,
        'contact-detail-form': ContactDetailForm,
        //'message-modal': MessageModal,
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			page: 1,
			showPagination: false,
			clientId: null,
			filters: {},
			list: [],
			definition: [],
			paging: {},
			contact: {},
			contact_history: [],
			showDetail: false,
			detailChanged: false,
			saving: false,
			saveMessage: '',
			showModal: false,
			modalMessage: '',
			modalForList: '',
			modalList: [],
			showNewModalInput: false
		}
	},
    created() {
		if (this.ffl_log_book_entry_id) {
			this.getDetail(this.ffl_log_book_entry_id)
		}
		this.clearFilters()
    },
    watch: {
		'$route.query': function(newRoute) {
			if (this.setFiltersFromRoute()) {
				this.getList()
			}
		},
    	searchTerm(newVal) {
    		if (!newVal) this.$router.push({ query: {} })
    	}
    },
	methods: {
		toggleFilter(which) {
			switch (which) {
				case 'type':
					this.filters.type = this.filters.type == 'supplier' ? 'disposed_to' : 'supplier'
					break;
				case 'acquisitions':
					this.filters.acquisitions = this.filters.acquisitions == 'acquisitions' ? '' : 'acquisitions'
					this.filters.disposals = ''
					break;
				case 'disposals':
					this.filters.disposals = this.filters.disposals == 'disposals' ? '' : 'disposals'
					this.filters.acquisitions = ''
					break;
			}
			this.getList()
		},
		getList() {
            this.loading = true
			this.showDetail = false
			this.detailChanged = false
			this.apiCall({ destination: 'get_list_logbook_contacts', data: this.filters }).then(obj => {
                this.loading = false
				this.list = obj.list
				this.definition = obj.definition
				this.paging = obj.paging
				this.clientId = obj.client_id
				this.showPagination = true
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		getDetail(contactId) {
			this.loading = true
			this.apiCall({ destination: 'get_item_contact', data: { contact_id: contactId } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.contact = obj.contact
					this.clientId = obj.client_id
					this.showPagination = false
					this.showDetail = true
					this.getContactHistory(contactId)
				}
			}).catch(err => {
				console.log(err)
				this.loading = false
			})
		},
		getContactHistory(contactId) {
			this.apiCall({ destination: 'get_list_contact_history', data: { contact_id: contactId, start_date: this.filters.start_date, end_date: this.filters.end_date } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.contact_history = obj.contact_history
				}
			}).catch(err => {
				console.log(err)
				this.loading = false
			})
		},
		updateContact(contact) {
			this.contact = contact
		},
		saveContact() {
			if (this.contact.client_id != this.clientId) { return }
			if (this.saving) { return }
			this.saving = true
			this.apiCall({ destination: 'save_item_contact', data: this.contact }).then(obj => {
				this.saving = false
				this.saveMessage = "Contact info info saved!"
				this.detailChanged = true
                setTimeout(() => {
					this.saveMessage = ""
                }, 3000)
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showDetail = false
			this.showPagination = true
			if (this.detailChanged) {
				this.getList()
			}
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		hasFilters() {
			for (var property in this.filters) {
				if (property != 'page' && this.filters[property] != '') {
					return true
				}
			}
			return false
		},
		setFiltersFromRoute() {
			if (this.$route.query.originator_contact_id) {
				this.filters.originator_contact_id = this.$route.query.originator_contact_id || ''
				return true
			}
			if (this.$route.query.originator_contact_id) {
				this.filters.disposal_contact_id = this.$route.query.disposal_contact_id || ''
				return true
			}
			if (this.$route.query.type) {
				this.filters.type = this.$route.query.type || 'supplier'
				return true
			}
			return false
		},
		clearFilters() {
			let filterType = this.$route.query.type || 'supplier'
			this.filters = {
				page: 1,
				search_term: '',
				type: filterType,
				start_date: '',
				end_date: '',
				originator_contact_id: this.$route.query.originator_contact_id || '',
				disposal_contact_id: this.$route.query.disposal_contact_id || ''
			}
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
/*.controls {
	@media all and (min-width: 1080px) {
		input { display: inline-block; max-width: 50% }
	}
}*/
</style>
